import {
  SettingSmallText,
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { TextInputStyled } from 'approot/shared/styles/inputs.style';

const SOURCE_URL = 'sourceUrl';

type Props = {
  sourceUrl: string | null;
  onChange: (value: string) => void;
};

const ComponentImageSource = ({ sourceUrl, onChange }: Props) => {
  return (
    <SettingsGroup>
      <SettingsLabel htmlFor={SOURCE_URL}>
        <Box $justifyContent="space-between" $marginBottom={0}>
          <span>Image Source URL</span>
          <SettingSmallText marginBottom={0}>Optional</SettingSmallText>
        </Box>
      </SettingsLabel>
      <TextInputStyled
        id={SOURCE_URL}
        name={SOURCE_URL}
        maxLength={1000}
        defaultValue={sourceUrl || ''}
        onChange={e => onChange(e.target.value)}
        data-selector="txt-source-url"
      />
      <SettingSmallText>
        Add source link to help others find this image.
      </SettingSmallText>
    </SettingsGroup>
  );
};

export default ComponentImageSource;
